import { JSX, useCallback } from "react";

import { format } from "date-fns/format";

import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import useListItemInfo, { ListItemInfo } from "lib/list/useListItemInfo";

import { TrashItem } from "./TrashTypes";

export type TrashTableRowProps = {
	item: TrashItem;
};

export default function TrashTableRow(
	props: Readonly<TrashTableRowProps>
): JSX.Element {
	const listInfo: ListItemInfo = useListItemInfo(props.item.id);

	const handleSelect = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>): void =>
			listInfo.select(event.target.checked),
		[listInfo.select]
	);

	if (!listInfo.visible) {
		return <></>;
	}

	return (
		<TableRow>
			<TableCell padding="checkbox">
				{listInfo.enabled && (
					<Checkbox
						checked={listInfo.selected}
						onChange={handleSelect}
					/>
				)}
			</TableCell>
			<TableCell>{props.item.name}</TableCell>
			<TableCell>{props.item.type}</TableCell>
			<TableCell>
				{format(
					new Date(props.item.statusModifiedOn),
					"dd/MM/yyyy HH:mm:ss"
				)}
			</TableCell>
			<TableCell>{props.item.statusModifiedByEmail}</TableCell>
		</TableRow>
	);
}
